<template>
  <div class="tag">
    {{tag}}
  </div>
</template>

<script>
export default {
  name: 'tag',
  props: ['tag', 'theme']
}
</script>

<style lang="scss">
  .tag {
    display: flex;
    padding: rem(2px) rem(8px);
    border-radius: 2px;
    font-weight: 700;
    font-size: rem(11px);
    line-height: rem(24px);
    text-transform: uppercase;
    margin: rem(3px) 0 rem(10px);
    -webkit-print-color-adjust: exact;
  }
</style>
